import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import { getserchKeyword, deleteserchKeyword } from '@/services/marketing/searchKeyword';
export default {
  name: 'serchKeyword',
  components: {},
  i18n: require('./i18n-searchKeyword'),
  data: function data() {
    return {
      isTableLoading: false,
      serchKeywordList: [],
      columns: [{
        //关键词名称
        dataIndex: 'searchKeywords',
        slots: {
          title: 'keywordTitle' //自定义标头
        },
        key: 'searchKeywords',
        width: '55%',
        ellipsis: true,
        scopedSlots: {
          customRender: 'searchKeywords' //自定义表格里面的内容
        }
      },
      //商品数量
      {
        title: this.$t('serchKeyword.productNum'),
        width: '15%',
        dataIndex: 'productNum',
        key: 'productNum'
      },
      //更新时间
      {
        title: this.$t('publicuse.updatetime'),
        dataIndex: 'lastUpdateTime',
        key: 'lastUpdateTime',
        width: '20%'
      },
      //操作
      {
        title: this.$t('publicuse.action'),
        dataIndex: 'action',
        key: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        width: '10%'
      }],
      defaultLangObj: JSON.parse(localStorage.defaultLangObj)
    };
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    //加载列表数据
    loadData: function loadData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.isTableLoading = true;
              _context.n = 1;
              return getserchKeyword();
            case 1:
              res = _context.v;
              try {
                if (res.data.code == 200) {
                  _this.serchKeywordList = res.data.data;
                }
              } finally {
                _this.isTableLoading = false;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    deleteKeyword: function deleteKeyword(id) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.isTableLoading = true;
              _context2.n = 1;
              return deleteserchKeyword(id);
            case 1:
              res = _context2.v;
              if (res.data.code == 200) {
                _this2.$message.success(_this2.$t('public.deleteSuccessfully'));
                _this2.loadData();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    add: function add() {
      this.$router.push({
        path: 'addSearchkeyword'
      });
    },
    edit: function edit(id) {
      this.$router.push({
        path: 'editSearchkeyword',
        query: {
          id: id
        }
      });
      // window.open(routeData.href, '_blank');
    }
  }
};